import styled from '@emotion/styled'
import * as React from 'react'

export type VerticalAttributeProps = {
  children: React.ReactNode
  name: React.ReactNode
}

const StyledItemBlock = styled.div`
  padding: 24px 16px;
  border-bottom: dashed 1px var(--White90);

  header {
    font-weight: 600;
  }

  .value {
    padding: 16px 0 0;
  }

  &:nth-last-of-type(-n + 2) {
    border-bottom: none;
  }

  &:nth-of-type(odd) {
    margin-right: 18px;
  }

  &:nth-of-type(even) {
    margin-left: 18px;
  }
`

export const VerticalAttribute = ({ children, name }: VerticalAttributeProps) => (
  <StyledItemBlock>
    <header>{name}</header>
    <div className="value">{children}</div>
  </StyledItemBlock>
)
